/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * Enum defining the types of insurance coverage or context for damages
 */
export enum CoverageTypeEnum {
  /**
   * Fully comprehensive insurance coverage (covers all types of damage, including self-inflicted)
   */
  FULLY_COMPREHENSIVE_COVERAGE = "FULLY_COMPREHENSIVE_COVERAGE",

  /**
   * Partially comprehensive insurance coverage (covers specific damages like theft, natural events)
   */
  PARTIALLY_COMPREHENSIVE_COVERAGE = "PARTIALLY_COMPREHENSIVE_COVERAGE",

  /**
   * Business liability insurance (e.g., damage in car wash or company garage door falls on vehicle)
   */
  BUSINESS_LIABILITY_COVERAGE = "BUSINESS_LIABILITY_COVERAGE",

  /**
   * Standard liability insurance (typically involving another party)
   */
  MOTORISTS_THIRD_PARTY_LIABILITY_COVERAGE = "MOTORISTS_THIRD_PARTY_LIABILITY_COVERAGE",

  /**
   * Breakdown or technical defect (not typically covered by standard insurance)
   */
  BREAKDOWN_OR_TECHNICAL_DEFECT = "BREAKDOWN_OR_TECHNICAL_DEFECT",

  /**
   * Other
   */
  OTHER = "OTHER"
}
